<template>
  <kst-container class="kst-stock-list">
    <kst-form
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :loading="isLoading"
      :title="title"
      :warnings="formWarnings"
    >
      <Export
        ref="refExport"
        :access="access"
        :items="items"
      />

      <kst-section search-mode class="pb-0">
        <Search
          :searchData="searchData"
          :warehouseOptions="warehouseOptions"
          :stockOptions="stockOptions"
          @reset="handleSearcReset"
          @submit="handleSearchSubmit"
        />
      </kst-section>

      <kst-section :loading="isListLoading" search-result-mode>
        <template #top-right>
          <kst-button action-mode
            class="is-primary mr-4"
            :module="Model.Module"
            :moduleType="Model.ModuleType.Print"
            :urlParams="urlParams"
          />
          <kst-button action-mode
            class="is-primary"
            tag="button"
            :module="Model.Module"
            :moduleType="Model.ModuleType.Export"
            @click="handleExport"
          />
        </template>

        <List
          :access="access"
          :failureList="failureList"
          :items="items"
          :isListLoading="isListLoading"
        />
      </kst-section>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import Model from "../StockModel.js";
import SearchCatalog from "./StockSearchCatalog.js";

import Export from "./StockList_Export";
import List from './StockList_List';
import Search from './StockList_Search';

import Services from "../StockServices.js";

export default {
  mixins: [AxiosMixin],
  components: {
    Export,
    List,
    Search
  },
  data: () => ({
    Model: Model,
    searchData: null,
    warehouseOptions: {},
    stockOptions: {},
    access: {},
    items: [],
    isLoading: false,
    isListLoading: false,
    // support debounce
    loadCounter: 0,
    // error
    failureInit: null,
    failureList: null,
    formWarnings: null,
    urlParams: "",
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.items = [];
      this.formWarnings = null;
      this.access = Model.createAccess();
      this.initSearch();
      this.initLoad();
    },
    initSearch() {
      // stock
      this.stockOptions = Model.createStockOptions(SearchCatalog.Stock.Label);

      // search
      this.searchData = {
        Search: "",
        WarehouseID: this.$kst.Search.OptionAll,
        Stock: this.$kst.Search.OptionAll
      };
    },
    initLoad() {
      this.isLoading = true;
      this.failureInit = null;

      this.loadListData();
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadListData() {
      const config = Services.getStockListData();
      this.runAxios(config, null,
        this.loadListData_Success,
        this.loadListData_Error,
        this.loadListData_Invalid
      );
    },
    loadListData_Success(data) {
      this.access = data.Access;
      this.loadCounter++;
      this.loadWarehouse();
      this.initLoad_End();
    },
    loadListData_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },
    loadListData_Invalid(message) {
      this.formWarnings = [message];
      this.initLoad_End();
    },

    loadWarehouse() {
      const config = Services.getWarehouseList();
      this.runAxios(config, null, this.loadWarehouse_Success, this.loadWarehouse_Error);
    },
    loadWarehouse_Success(data) {
      this.warehouseOptions = Model.getWarehouseOptions(
        data, SearchCatalog.WarehouseID.Label
      );
      this.loadCounter++;
      this.loadList(this.loadCounter, this.searchData);
      this.initLoad_End();
    },
    loadWarehouse_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },

    loadList(counter, searchData) {
      this.failureList = null;
      this.isListLoading = true;
      this.items = [];

      let options = {};
      if (searchData) {
        options.name = this.$kst.Out.getString(searchData.Search);
        options.availstock = this.$kst.Search.getValue(searchData.Stock);
        options.field = Model.Search.Fields;
        options.warehouse = this.$kst.Search.getValue(searchData.WarehouseID);
      }

      this.urlParams = this.$kst.Route.getParams(searchData);
      const config = Services.getStockList(options);
      this.runAxios(config, counter, this.loadList_Success, this.loadList_Error);
    },
    loadList_End() {
      this.isListLoading = false;
    },
    loadList_Success(data, counter) {
     // handle repeated execution on slow network to show last request
      if (counter !== this.loadCounter) {
        return;
      }

      this.items = data;
      this.loadList_End();
    },
    loadList_Error(message) {
      this.failureList = message;
      this.isListLoading = false;
    },

    handleExport() {
      this.$refs.refExport.exportExcel();
    },

    handleSearchSubmit() {
      this.loadCounter++;
      this.loadList(this.loadCounter, this.searchData);
    },
    handleSearcReset() {
      this.initSearch();
      this.loadCounter++;
      this.loadList(this.loadCounter, this.searchData);
    }
  }
}
</script>